/**
 * File: useChatActions.ts
 * Description: Hook for accessing chat actions context
 * Author: System
 * Created: 2025-11-13
 */

import { createContext, useContext } from 'react';

import { ChatAction } from '../types/chat';

export interface PendingChatAction extends ChatAction {
  internalId: string;
}

export interface ActionExecutionResult {
  message?: string;
}

export interface ChatActionsContextValue {
  pendingConfirmations: PendingChatAction[];
  confirmPendingAction: (_action: PendingChatAction) => Promise<ActionExecutionResult>;
  dismissPendingAction: (_action: PendingChatAction) => void;
  processingActionId: string | null;
}

export const ChatActionsContext = createContext<ChatActionsContextValue | undefined>(undefined);

export const useChatActions = (): ChatActionsContextValue => {
  const context = useContext(ChatActionsContext);
  if (!context) {
    throw new Error('useChatActions must be used within ChatActionsContext');
  }
  return context;
};
